import { KeywordSuggestion, PeopleSuggestion, SuggestionKind } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import {
    addSuggestionPill,
    onSearchTextChanged,
    lazySetIsSuggestionsDropdownVisible,
    startSearch,
    suggestionSelected,
} from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';

export default orchestrator(suggestionSelected, async actionMessage => {
    if (actionMessage.scenarioId != SearchScenarioId.Spaces) {
        return;
    }

    const { suggestion } = actionMessage;

    // Hide suggestions dropdown.
    const setIsSuggestionsDropdownVisible = await lazySetIsSuggestionsDropdownVisible.import();
    setIsSuggestionsDropdownVisible(false, SearchScenarioId.Spaces);

    switch (suggestion.kind) {
        case SuggestionKind.Keywords: {
            handleKeywordSuggestion(suggestion);
            break;
        }
        case SuggestionKind.People: {
            handlePeopleSuggestion(suggestion);
            break;
        }
        default:
            break;
    }
});

function handleKeywordSuggestion(suggestion: KeywordSuggestion) {
    onSearchTextChanged(suggestion.QueryText, SearchScenarioId.Spaces);
    if (suggestion.QueryText) {
        startSearch(
            'SearchBoxSuggestionDropDownKeyword',
            SearchScenarioId.Spaces,
            false /* explicitSearch */
        );
    }
}

function handlePeopleSuggestion(suggestion: PeopleSuggestion) {
    addSuggestionPill(suggestion, true /* suggestionSelected */, SearchScenarioId.Spaces);
    if (suggestion.QueryText) {
        startSearch(
            'SearchBoxSuggestionDropDownPeople',
            SearchScenarioId.Spaces,
            false /* explicitSearch */
        );
    }
}
